import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 24px 16px;
`;

export const Modal = styled.form`
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 640px;
  padding: 30px 34px;
  display: flex;
  flex-direction: column;
  gap: 26px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  max-height: 90vh;
  overflow-y: auto;
`;

export const SectionTitle = styled.h2`
  color: #1b2b3a;
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0 0 -8px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 24px;
  align-items: start;

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 0.88rem;
  color: #333;
`;

const control = `
  padding: 11px 13px;
  border-radius: 6px;
  font-size: 0.9rem;
  color: #222;
  outline: none;
  font-family: inherit;
  width: 100%;
  box-sizing: border-box;
`;

export const Input = styled.input`
  ${control}
  background: #fff;
  border: 1px solid ${({ $error }) => ($error ? "#e05c5c" : "#dfe6ec")};

  &:focus { border-color: ${({ $error }) => ($error ? "#e05c5c" : "#26A9B6")}; }

  /* Campos no editables: usuario, email y código de hospital */
  &:disabled {
    background: #f0f2f4;
    color: #55606b;
    cursor: not-allowed;
  }
`;

export const Textarea = styled.textarea`
  ${control}
  background: #fff;
  border: 1px solid #dfe6ec;
  min-height: 84px;
  resize: vertical;

  &:focus { border-color: #26A9B6; }
`;

export const Hint = styled.p`
  margin: 0;
  font-size: 0.76rem;
  line-height: 1.35;
  color: ${({ $error }) => ($error ? "#e05c5c" : "#9aa7b2")};
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 4px;
`;

export const CancelButton = styled.button`
  padding: 10px 22px;
  border-radius: 7px;
  border: 1.5px solid #dfe6ec;
  background: #fff;
  color: #55606b;
  font-size: 0.88rem;
  cursor: pointer;

  &:hover { background: #f5f7f9; }
`;

export const SaveButton = styled.button`
  padding: 10px 22px;
  border-radius: 7px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #175a65; }
  &:disabled { background: #8b8b8b; cursor: not-allowed; }
`;
